<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Subscription'"
      [canGoBack]="true"
      [customBack]="windowService.isDesktopRes ? 'more/payment-options' : 'more'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (!loaded && !windowService.isDesktopRes) {
      <ion-skeleton-text animated style="margin-left: -20px; margin-right: -20px; width: 100%; position: absolute; height: 100%; top: 0; bottom: 0" />
    }

    @if (loaded) {
      @if (isAccountSuspended || hasNegativeBalance) {
        <tidy-card>
          <tidy-row>
            <tidy-row>
              <tidy-image [src]="'assets/img/black-alert.svg'" />
              <tidy-text [header]="hasNegativeBalance ? 'Your Subscription Payment Failed' : 'Plan Canceled Due to Failed Payment'"/>
            </tidy-row>
            <tidy-row>
              <tidy-text [body]="hasNegativeBalance ? 'Please select a payment method and confirm your subscription.' : 'Please select a payment method and a subscription.'"/>
            </tidy-row>
          </tidy-row>
          <tidy-button
            [text]="'Pay Balance & Update Subscription'"
            [action]="goToChangeSubscriptionPage.bind(this)"
            class="primary" />
        </tidy-card>
      }
      @if (!isAccountSuspended) {
        @if (currentSubscription?.plan?.key === 'autopilot-us') {
          <tidy-alert>
            <tidy-row>
              <tidy-text [body]="'You don\'t have a subscription'" />&nbsp;
              <tidy-text
                [actionBody]="'Subscribe Now'"
                (action)="goToSubscribe()"
                class="white-link" />
            </tidy-row>
          </tidy-alert>
        } @else if (hasReservationFeePlan) {
          <subscription-plan-card
            [editLinkText]="'Edit Subscription'"
            (editLinkClicked)="goToEditSubscription()"
            [unitCount]="billableAddresses"
            [baseMinimumPerUnit]="baseMinimumPerUnit"
            [cleaningMaintenancePerUnit]="cleaningMaintenancePerUnit"
            [feePercent]="reservationFeePercent"
            [footnote]="nextChargeNote"
            [(cleaningMaintenanceOn)]="cleaningMaintenanceOn"
            (cleaningMaintenanceToggled)="onCleaningMaintenanceToggled($event)"
            (hardwareAddOnTapped)="gateHardwareAddOn()" />
          @if (nextSubscription) {
            <tidy-row class="extra-top-padding">
              <tidy-text
                [body]="'You changed to a'" /><span>&nbsp;</span>
              <tidy-text
                [body]="nextSubscription?.plan?.description" /><span>&nbsp;</span>
              <tidy-text
                [body]="'. This change will take effect on'" /><span>&nbsp;</span>
              <tidy-text
                [body]="(nextSubscription?.next_charge_on | parseDateTime:'MMM d yyyy') + '.'" />
            </tidy-row>
          }
        } @else {
        <tidy-card>
          <!--<tidy-row [alignLastItemRight]="true" class="extra-bottom-padding">
            <tidy-text
              [header]="currentSubscription?.plan?.description" />
            <tidy-text
              [body]="'Edit'"
              (action)="goToChangeSubscriptionPage()"
              class="link" />
          </tidy-row>-->
          @if (currentSubscription?.plan?.key === 'flex') {
            <tidy-row>
              <tidy-text
                [header]="'Flex'"/>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="currentSubscription?.plan?.debit_strategies?.debit_fee_by_private_job?.fee_percent_by_job + '% '"/>
              <tidy-text
                [body]="'/ job (debited when the pro completes the job)'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Min fee per job: '" />
              <tidy-text
                [body]="currentSubscription?.plan?.debit_strategies?.debit_fee_by_private_job?.min_fee_amount_by_job | tcurrency" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Max fee per job: '" />
              <tidy-text
                [body]="currentSubscription?.plan?.debit_strategies?.debit_fee_by_private_job?.max_fee_amount_by_job | tcurrency" />
            </tidy-row>
          }
          @if (currentSubscription?.plan?.key.includes('autopilot')) {
            <tidy-row>
              <tidy-text
                [header]="'Autopilot'"/>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="currentSubscription?.plan?.debit_strategies?.debit_fee_by_private_job?.fee_percent_by_job + '% '"/>
              <tidy-text
                [body]="'/ job (debited when the pro completes the job)'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Min fee per job: '" />
              <tidy-text
                [body]="currentSubscription?.plan?.debit_strategies?.debit_fee_by_private_job?.min_fee_amount_by_job | tcurrency" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Max fee per job: '" />
              <tidy-text
                [body]="currentSubscription?.plan?.debit_strategies?.debit_fee_by_private_job?.max_fee_amount_by_job | tcurrency" />
            </tidy-row>
          } @else if (currentSubscription?.plan?.debit_strategies?.debit_by_address) {
            <tidy-row>
              <tidy-text
                [header]="currentSubscription?.plan?.description"/>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="(currentSubscription?.plan?.debit_strategies?.debit_by_address?.amount_by_address | tcurrency) + ' '"/>
              <tidy-text
                [body]="('/ address / ' | translate) + subscriptionType" />
            </tidy-row>
            @if (currentSubscription?.plan?.debit_strategies?.debit_by_address?.number_of_free_addresses > 0) {
              <tidy-row>
                <tidy-text
                  [body]="('Free addresses: ' | translate) + currentSubscription?.plan?.debit_strategies?.debit_by_address?.number_of_free_addresses" />
              </tidy-row>
            }
            <tidy-row>
              <tidy-text
                [body]="('Billable addresses: ' | translate) + billableAddresses" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Total: '"/>
              <tidy-text
                [body]="bill | tcurrency" />
            </tidy-row>
          } @else if (currentSubscription?.plan) {
            <tidy-row>
              <tidy-text
                [header]="currentSubscription?.plan?.description"/>
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="('Renewal: ' | translate) + subscriptionType" />
            </tidy-row>
            @if (currentSubscription?.next_charge_on) {
              <tidy-row>
                <tidy-text
                  [body]="'Next charge: '"/><span>&nbsp;</span>
                <tidy-text
                  [body]="currentSubscription?.next_charge_on | parseDateTime:'MMM d yyyy'" />
              </tidy-row>
            }
          }
          @if (nextSubscription) {
            <tidy-row class="extra-top-padding extra-bottom-padding">
              <tidy-divider />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'You changed to a'" /><span>&nbsp;</span>
              <tidy-text
                [body]="nextSubscription?.plan?.description" /><span>&nbsp;</span>
              <tidy-text
                [body]="'. This change will take effect on'" /><span>&nbsp;</span>
              <tidy-text
                [body]="(nextSubscription?.next_charge_on | parseDateTime:'MMM d yyyy') + '.'" />
            </tidy-row>
          }
        </tidy-card>
        }
      }
      <tidy-row class="extra-top-padding">
        <tidy-text
          [title]="'Billing History'" />
      </tidy-row>
      @for (invoice of subscriptionInvoices; track invoice) {
        <tidy-card>
          <tidy-row>
            <tidy-text
              [header]="invoice?.subscription?.plan?.description" />
          </tidy-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/clock.svg'"
              class="header-size" />
            <tidy-text
              [body]="'Period:'" /><span>&nbsp;</span>
            <tidy-text
              [body]="(invoice?.start_date | parseDateTime:'MMM d yyyy') + ' - ' + (invoice?.end_date | parseDateTime:'MMM d yyyy')" />
          </tidy-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/img/credit-card.svg'"
              class="header-size" />
            <tidy-text
              [body]="invoice?.paid_amount | tcurrency" /><span>&nbsp;</span>
            <tidy-text
              [body]="'paid of'" /><span>&nbsp;</span>
            <tidy-text
              [body]="invoice?.total_amount | tcurrency" />
          </tidy-row>
        </tidy-card>
      }
      @if (subscriptionInvoices?.length == 0) {
        <tidy-alert>
          <tidy-row>
            <tidy-text
              [body]="'No history'" />
          </tidy-row>
        </tidy-alert>
      }
      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Please '"/>
        <tidy-text
          [body]="'contact'"
          (action)="goToContactConcierge()"
          class="white-link" />
        <tidy-text
          [body]="' our concierge for any questions or changes. We are happy to help get it right.'"/>
      </tidy-row>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
